
module.exports = [   
    {
      id: "dealName",
      fieldName: "Deal Name",
    },   
    {
      id: "dealOwner",
      fieldName: "Deal Owner",
    },   
    {
      id: "stage",
      fieldName: "Stage",
    }
  ];